export default __webpack_public_path__ + "static/media/percentage-indicator-down.53b5dfe2.svg";